import { VocabularyWordStatType } from "seneca-common/features/assignments/features/student-assignments/state/models/VocabularyWordStat";

export function getBestScore(vocabularyWordStat: VocabularyWordStatType) {
  return vocabularyWordStat.bestScore;
}

export function getTotalStudyTime(vocabularyWordStat: VocabularyWordStatType) {
  return vocabularyWordStat.totalStudyTime;
}

export function getAverageScore(vocabularyWordStat: VocabularyWordStatType) {
  return vocabularyWordStat.averageScore;
}

export function getFirstScore(vocabularyWordStat: VocabularyWordStatType) {
  return vocabularyWordStat.firstScore;
}

export function getLastScore(vocabularyWordStat: VocabularyWordStatType) {
  return vocabularyWordStat.lastScore;
}

export function getWorstScore(vocabularyWordStat: VocabularyWordStatType) {
  return vocabularyWordStat.worstScore;
}

export function getSessionsCompleted(
  vocabularyWordStat: VocabularyWordStatType
) {
  return vocabularyWordStat.sessionsCompleted;
}
